import { NextPage, NextPageContext } from 'next';

import { BasketPageModule } from '@/components/modules/basket-page';
import { getCreditProductsForCalc } from '@/components/modules/caclulator/api';
import { TVariantsCreditProducts } from '@/components/modules/caclulator/types';
import { TRootStateType, wrapperReduxToolkit } from '@/store';
import { loadPopularProducts } from '@/store/reducers/rent/action-creators';
import { loadCheckIsNewQuestionnaireAllowed } from '@/store/reducers/user/action-creators';
import { loadDefaultData } from '@/store/utils/load-default-data';

import { Footer } from '@/widgets/footer';
import { Header } from '@/widgets/header';

import { HeadMeta, getMetaDataPage } from '@/entities/meta-seo';
import { TRentProduct } from '@/entities/product';

import { BASKET_URL } from '@/shared/constants/paths';
import { Layout } from '@/shared/ui/layout';

type TProps = {
    title: string;
    description: string;
    popularProducts: TRentProduct[];
    variantsCreditProducts: TVariantsCreditProducts;
};

const Index: NextPage<TProps> = ({ description, title, popularProducts, variantsCreditProducts }) => {
    return (
        <Layout header={<Header />} footer={<Footer />}>
            <HeadMeta title={title} description={description} />
            <BasketPageModule variantsCreditProducts={variantsCreditProducts} popularProducts={popularProducts} />
        </Layout>
    );
};

Index.getInitialProps = wrapperReduxToolkit.getInitialPageProps(
    ({ dispatch, getState }) =>
        async (context: NextPageContext) => {
            const { locale } = context;

            // Загрузка стора при серверном и клиенском рединге, общих настроек
            const { user } = await loadDefaultData({
                getState,
                dispatch,
                locale: locale as string,
                context,
            });

            await dispatch(loadPopularProducts({ cityKatoid: user.cityUser.katoid }));

            const response = await Promise.all([
                getMetaDataPage(BASKET_URL, locale as string),
                getCreditProductsForCalc(),
            ]);

            const state: TRootStateType = getState();

            if (state.user.auth.authenticated) {
                await dispatch(loadCheckIsNewQuestionnaireAllowed(context));
            }

            return {
                metaData: response[0],
                variantsCreditProducts: response[1],
                popularProducts: state.rent.popularProducts.data,
            };
        },
);

export default Index;
